import { render } from "./FirstStep.vue?vue&type=template&id=0e05554e&scoped=true"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"

import "./FirstStep.vue?vue&type=style&index=0&id=0e05554e&scoped=true&lang=scss"

import exportComponent from "C:\\BestPhone\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e05554e"]])

export default __exports__